/// <reference path="wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    const CSS_ID_ATTRIBUTE = 'data-css-id';
    const LOG_CATEGORY = "WPT.Loader";
    /**
     * Class for the loading of resources. No dependencies to other WPT "modules".
     */
    class LoaderManager {
        constructor(core) {
            this._log = null;
            this._jsCallbackQueue = null;
            this._jsErrorQueue = null;
            this._jsLoaded = null;
            this._jsFailed = null;
            this._cssCallbackQueue = null;
            this._cssErrorQueue = null;
            this._cssLoaded = null;
            this._cssFailed = null;
            this._currentCssId = null;
            this.initLogging = () => {
                
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
            };
            /**
             * Get an unversioned JSON file and execute callback with JSON response.
             * @param url URL to the JSON file
             * @param callback callback function to be executed with the JSON from file
             * @param errorCallback optional callback function in error case
             */
            this.getUnversionedJSON = (url, callback, errorCallback) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.getUnversionedJSON()");
                }
                this._getJSON(url, callback, false, errorCallback);
            };
            /**
             * Get a versioned JSON file and execute callback with JSON response.
             * @param url URL to the JSON file
             * @param callback callback function to be executed with the JSON from file
             * @param errorCallback optional callback function in error case
             */
            this.getVersionedJSON = (url, callback, errorCallback) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.getVersionedJSON()");
                }
                this._getJSON(url, callback, true, errorCallback);
            };
            /**
             * Get an unversioned HTML file and execute callback with HTML response.
             * @param url URL to the HTML file
             * @param callback callback function to be executed with the HTML from file
             * @param errorCallback optional callback function in error case
             */
            this.getUnversionedHTML = (url, callback, errorCallback) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.getUnversionedHTML()");
                }
                this._getHTML(url, callback, false, errorCallback);
            };
            /**
             * Get a versioned HTML file and execute callback with HTML response.
             * @param url URL to the HTML file
             * @param callback callback function to be executed with the HTML from file
             * @param errorCallback optional callback function in error case
             */
            this.getVersionedHTML = (url, callback, errorCallback) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.getVersionedHTML()");
                }
                this._getHTML(url, callback, true, errorCallback);
            };
            /**
             * Get an unversioned CSS file and execute callback with CSS response.
             * @param url URL to the CSS file
             * @param callback callback function to be executed with the CSS from file
             * @param errorCallback optional callback function in error case
             */
            this.getUnversionedCSS = (url, callback, errorCallback) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.getUnversionedCSS()");
                }
                this._getCSS(url, callback, false, errorCallback);
            };
            /**
             * Get a versioned CSS file and execute callback with CSS response.
             * @param url URL to the CSS file
             * @param callback callback function to be executed with the CSS from file
             * @param errorCallback optional callback function in error case
             */
            this.getVersionedCSS = (url, callback, errorCallback) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.getVersionedCSS()");
                }
                this._getCSS(url, callback, true, errorCallback);
            };
            /**
             * Adds an unversioned CSS file to the page.
             * @param url URL to the CSS file
             */
            this.loadUnversionedCSS = (url) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.loadUnversionedCSS()");
                }
                this._loadCSS(url, false);
            };
            /**
             * Adds a versioned CSS file to the page.
             * @param url URL to the CSS file
             */
            this.loadVersionedCSS = (url) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.loadVersionedCSS()");
                }
                this._loadCSS(url, true);
            };
            /**
             * Loads the CSS file for a new 'application' and removes the dynamically added CSS files.
             */
            this.resetCSS = (url, versioned, errorCallback = null) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.resetCSS()");
                }
                let oldStyle = document.querySelector('#applicationStyle');
                if (oldStyle) {
                    if (!url) {
                        oldStyle.innerHTML = '';
                    }
                    else
                        oldStyle.id = 'oldApplicationStyle';
                }
                let oldCssId = this._currentCssId;
                this._currentCssId = 'css-id-' + performance.now();
                this._cssLoaded[this._currentCssId] = {};
                this._cssFailed[this._currentCssId] = {};
                if (url) {
                    if (typeof url != 'object') {
                        this._getCSS(url, this._changeCSS.bind(this, oldCssId), versioned, errorCallback);
                    }
                    else {
                        let remoteSpec = {
                            Instance: url.Instance,
                            FileType: 'APPLICATION-STYLESHEET',
                            Id: url.Id
                        };
                        this.retrieveConfigData(remoteSpec, this._changeCSS.bind(this, oldCssId), errorCallback);
                    }
                }
            };
            /**
             * Adds an unversioned JS file to the page.
             * @param url URL to the JS file
             * @param callback callback function to be executed when the JS file is added to the page
             */
            this.loadUnversionedJS = (url, callback, errorCallback = null) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.loadUnversionedJS()");
                }
                this._loadJS(url, callback, false, errorCallback);
            };
            /**
             * Adds a versioned JS file to the page.
             * @param url URL to the JS file
             * @param callback callback function to be executed when the JS file is added to the page
             */
            this.loadVersionedJS = (url, callback, errorCallback = null) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.loadVersionedJS()");
                }
                this._loadJS(url, callback, true, errorCallback);
            };
            /**
             * Executes authentication call.
             * @param user name of the user to authenticate
             * @param password password of the user to authenticate
             * @param callback callback function with the successful login response
             * @param errorCallback optional callback function in error case
             * @param failCallback optional callback function in failed case
             */
            this.basicAuthenticationCall = (user, password, callback, errorCallback, failCallback) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.basicAuthenticationCall()");
                }
                let fullPath = this._core.getServer() + '/Config.svc/rest/LoginBasicAuth';
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("doing AJAX call to: " + fullPath);
                }
                try {
                    let xmlhttp = new XMLHttpRequest();
                    let loader = this;
                    xmlhttp.onerror = function () {
                        if (errorCallback) {
                            errorCallback(fullPath, this.status, this.statusText);
                        }
                        else {
                            console.error("failed to do basic authentication call to '" + fullPath + "' got status " + this.status + " - " +
                                this.statusText + " and response: " + this.responseText);
                        }
                    };
                    // handling change of ready state (function has its own 'this')
                    xmlhttp.onreadystatechange = function () {
                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                            loader._log.trace("readyState: " + this.readyState + ", status: " + this.status + ", url: " + fullPath);
                        }
                        if (this.readyState == 4) { // AJAX response complete
                            if (this.status == 200) { // AJAX request was successful
                                let shortenedText = this.responseText.length > 500 ? this.responseText.substring(0, 500) + "..." : this.responseText;
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("got response: " + shortenedText);
                                }
                                let response = JSON.parse(this.responseText);
                                if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Error') && response.Connection.Error) {
                                    if (failCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling fail callback with: " + response);
                                        }
                                        failCallback(response);
                                    }
                                    else if (errorCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling error callback with: " + shortenedText);
                                        }
                                        errorCallback(fullPath, this.status, this.responseText);
                                    }
                                    else {
                                        console.error("no error callback - failed to do basic authentication call to '" + fullPath + "' got message: " +
                                            response.Connection.Message);
                                    }
                                }
                                else {
                                    if (loader._log !== null && loader._log.isTraceEnabled()) {
                                        loader._log.trace("calling callback with: " + response);
                                    }
                                    callback(response);
                                }
                            }
                            else if (this.status > 0) { // AJAX request not successful
                                let contentType = this.getResponseHeader('content-type');
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("content-type: " + contentType);
                                }
                                let shortenedText = this.responseText.length > 500 ? this.responseText.substring(0, 500) + "..." : this.responseText;
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("got response: " + shortenedText);
                                }
                                if (contentType !== null && contentType.startsWith('application/json')) {
                                    let response = JSON.parse(this.responseText);
                                    if (failCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling fail callback with: " + response);
                                        }
                                        failCallback(response);
                                    }
                                    else {
                                        console.error("no fail callback - failed to do basic authentication call to '" + fullPath + "' got message: " +
                                            response.Connection.Message);
                                    }
                                }
                                else {
                                    if (errorCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling error callback with: " + shortenedText);
                                        }
                                        errorCallback(fullPath, this.status, this.responseText);
                                    }
                                    else {
                                        console.error("no error callback - failed to do basic authentication call to '" + fullPath + "' got status " + this.status + " - " +
                                            this.statusText + " and response: " + this.responseText);
                                    }
                                }
                            }
                            else {
                                console.error("failed to do basic authentication call to '" + fullPath + "' got status " + this.status + " - " +
                                    this.statusText + " and response: " + this.responseText);
                            }
                        }
                    };
                    xmlhttp.open("GET", fullPath, true);
                    // add flag to keep Application object open (name 'IsDisconnectEnabled' [sic] is misleading)
                    xmlhttp.setRequestHeader('IsDisconnectEnabled', 'true');
                    // set selected locale as accept-language header for service layer to use it, if needed
                    if (this._core.Locale.getSelectedLocale()) {
                        xmlhttp.setRequestHeader('Accept-Language', this._core.Locale.getSelectedLocale().LocaleCode);
                    }
                    // add authorisation information
                    let safeUser = this._core.Functions.safeEncodeURIComponent(user);
                    let safePassword = this._core.Functions.safeEncodeURIComponent(password);
                    xmlhttp.setRequestHeader('Authorization', 'Basic ' + window.btoa(safeUser + ':' + safePassword));
                    xmlhttp.send();
                }
                catch (ex) {
                    console.error("error while doing basic authentication call to '" + fullPath + "': ", ex.message);
                    if (errorCallback) {
                        errorCallback(fullPath, 0, ex.message);
                    }
                }
            };
            /**
             * Executes authentication call.
             * @param user name of the user to authenticate
             * @param password password of the user to authenticate
             * @param callback callback function with the successful login response
             * @param errorCallback optional callback function in error case
             * @param failCallback optional callback function in failed case
             */
            this.idpAuthenticationCall = (token, callback, errorCallback, failCallback) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.idpAuthenticationCall()");
                }
                let fullPath = this._core.getServer() + '/Config.svc/rest/LoginIdP';
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("doing AJAX call to: " + fullPath);
                }
                try {
                    let xmlhttp = new XMLHttpRequest();
                    let loader = this;
                    xmlhttp.onerror = function () {
                        if (errorCallback) {
                            errorCallback(fullPath, this.status, this.statusText);
                        }
                        else {
                            console.error("failed to do basic authentication call to '" + fullPath + "' got status " + this.status + " - " +
                                this.statusText + " and response: " + this.responseText);
                        }
                    };
                    // handling change of ready state (function has its own 'this')
                    xmlhttp.onreadystatechange = function () {
                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                            loader._log.trace("readyState: " + this.readyState + ", status: " + this.status + ", url: " + fullPath);
                        }
                        if (this.readyState == 4) { // AJAX response complete
                            if (this.status == 200) { // AJAX request was successful
                                let shortenedText = this.responseText.length > 500 ? this.responseText.substring(0, 500) + "..." : this.responseText;
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("got response: " + shortenedText);
                                }
                                let response = JSON.parse(this.responseText);
                                if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Error') && response.Connection.Error) {
                                    if (failCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling fail callback with: " + response);
                                        }
                                        failCallback(response);
                                    }
                                    else if (errorCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling error callback with: " + shortenedText);
                                        }
                                        errorCallback(fullPath, this.status, this.responseText);
                                    }
                                    else {
                                        console.error("no error callback - failed to do basic authentication call to '" + fullPath + "' got message: " +
                                            response.Connection.Message);
                                    }
                                }
                                else {
                                    if (loader._log !== null && loader._log.isTraceEnabled()) {
                                        loader._log.trace("calling callback with: " + response);
                                    }
                                    callback(response);
                                }
                            }
                            else if (this.status > 0) { // AJAX request not successful
                                let contentType = this.getResponseHeader('content-type');
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("content-type: " + contentType);
                                }
                                let shortenedText = this.responseText.length > 500 ? this.responseText.substring(0, 500) + "..." : this.responseText;
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("got response: " + shortenedText);
                                }
                                if (contentType !== null && contentType.startsWith('application/json')) {
                                    let response = JSON.parse(this.responseText);
                                    if (failCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling fail callback with: " + response);
                                        }
                                        failCallback(response);
                                    }
                                    else {
                                        console.error("no fail callback - failed to do basic authentication call to '" + fullPath + "' got message: " +
                                            response.Connection.Message);
                                    }
                                }
                                else {
                                    if (errorCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling error callback with: " + shortenedText);
                                        }
                                        errorCallback(fullPath, this.status, this.responseText);
                                    }
                                    else {
                                        console.error("no error callback - failed to do basic authentication call to '" + fullPath + "' got status " + this.status + " - " +
                                            this.statusText + " and response: " + this.responseText);
                                    }
                                }
                            }
                            else {
                                console.error("failed to do basic authentication call to '" + fullPath + "' got status " + this.status + " - " +
                                    this.statusText + " and response: " + this.responseText);
                            }
                        }
                    };
                    xmlhttp.open("POST", fullPath, true);
                    // add flag to keep Application object open (name 'IsDisconnectEnabled' [sic] is misleading)
                    xmlhttp.setRequestHeader('IsDisconnectEnabled', 'true');
                    // set selected locale as accept-language header for service layer to use it, if needed
                    if (this._core.Locale.getSelectedLocale()) {
                        xmlhttp.setRequestHeader('Accept-Language', this._core.Locale.getSelectedLocale().LocaleCode);
                    }
                    xmlhttp.setRequestHeader("Content-Type", "application/json");
                    // add authorisation information
                    let request = { Token: token };
                    xmlhttp.send(JSON.stringify(request));
                }
                catch (ex) {
                    console.error("error while doing basic authentication call to '" + fullPath + "': ", ex.message);
                    if (errorCallback) {
                        errorCallback(fullPath, 0, ex.message);
                    }
                }
            };
            /**
             * Executes disconnect call.
             * @param callback callback function with the successful logoff response
             * @param errorCallback optional callback function in error case
             * @param failCallback optional callback function in failed case
             */
            this.disconnectCall = (callback, errorCallback, failCallback) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.disconnectCall()");
                }
                let fullPath = this._core.getServer() + '/Config.svc/rest/disconnect';
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("doing AJAX call to: " + fullPath);
                }
                try {
                    let xmlhttp = new XMLHttpRequest();
                    let loader = this;
                    xmlhttp.onerror = function () {
                        if (errorCallback) {
                            errorCallback(fullPath, this.status, this.statusText);
                        }
                        else {
                            console.error("failed to do disconnect call to '" + fullPath + "' got status " + this.status + " - " +
                                this.statusText + " and response: " + this.responseText);
                        }
                    };
                    // handling change of ready state (function has its own 'this')
                    xmlhttp.onreadystatechange = function () {
                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                            loader._log.trace("readyState: " + this.readyState + ", status: " + this.status + ", url: " + fullPath);
                        }
                        if (this.readyState == 4) { // AJAX response complete
                            if (this.status == 200) { // AJAX request was successful
                                let shortenedText = this.responseText.length > 500 ? this.responseText.substring(0, 500) + "..." : this.responseText;
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("got response: " + shortenedText);
                                }
                                let response = JSON.parse(this.responseText);
                                if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Error') && response.Connection.Error) {
                                    if (failCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling fail callback with: " + response);
                                        }
                                        failCallback(response);
                                    }
                                    else if (errorCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling error callback with: " + this.statusText);
                                        }
                                        errorCallback(fullPath, this.status, this.statusText);
                                    }
                                    else {
                                        console.error("no error callback - failed to do disconnect call to '" + fullPath + "' got message: " +
                                            response.Connection.Message);
                                    }
                                }
                                else {
                                    if (loader._log !== null && loader._log.isTraceEnabled()) {
                                        loader._log.trace("calling callback with: " + response);
                                    }
                                    callback(response);
                                }
                            }
                            else if (this.status > 0) { // AJAX request not successful
                                let shortenedText = this.responseText.length > 500 ? this.responseText.substring(0, 500) + "..." : this.responseText;
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("got response: " + shortenedText);
                                }
                                let response = JSON.parse(this.responseText);
                                if (failCallback) {
                                    if (loader._log !== null && loader._log.isTraceEnabled()) {
                                        loader._log.trace("calling fail callback with: " + response);
                                    }
                                    failCallback(response);
                                }
                                else if (errorCallback) {
                                    if (loader._log !== null && loader._log.isTraceEnabled()) {
                                        loader._log.trace("calling error callback with: " + this.statusText);
                                    }
                                    errorCallback(fullPath, this.status, this.statusText);
                                }
                                else {
                                    console.error("no error callback - failed to do disconnect call to '" + fullPath + "' got message: " +
                                        response.Connection.Message);
                                }
                            }
                            else {
                                console.error("failed to do disconnect call to '" + fullPath + "' got status " + this.status + " - " +
                                    this.statusText + " and response: " + this.responseText);
                            }
                        }
                    };
                    xmlhttp.open("GET", fullPath, true);
                    // add connection id for authorisation
                    xmlhttp.setRequestHeader('ConnectionId', this._core.getCurrentConnectionId());
                    // add user name (probably not used in REST API)
                    xmlhttp.setRequestHeader('Username', this._core.getCurrentUsername());
                    // set selected locale as accept-language header for service layer to use it, if needed
                    if (this._core.Locale.getSelectedLocale()) {
                        xmlhttp.setRequestHeader('Accept-Language', this._core.Locale.getSelectedLocale().LocaleCode);
                    }
                    xmlhttp.send();
                }
                catch (ex) {
                    console.error("error while doing disconnect call to '" + fullPath + "': ", ex.message);
                    if (errorCallback) {
                        errorCallback(fullPath, 0, ex.message);
                    }
                }
            };
            /**
             * Executes generic service call to get raw data (arraybuffer).
             * @param methodCall endpoint and method to call
             * @param callback callback function with the successful response
             * @param errorCallback optional callback function in error case
             * @param useProxy optional decision whether to use the proxy user (default: false)
             */
            this.genericServiceCallRawData = (methodCall, callback, errorCallback, headers = {}, useProxy = false) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.genericServiceCallRawData()");
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("calling method: " + methodCall);
                }
                let fullPath = this._core.getServer() + methodCall;
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("doing AJAX call to: " + fullPath);
                }
                try {
                    let xmlhttp = new XMLHttpRequest();
                    let loader = this;
                    xmlhttp.onerror = function () {
                        if (errorCallback) {
                            errorCallback(fullPath, this.status, this.statusText);
                        }
                        else {
                            console.error("failed to do generic service call raw data to '" + fullPath + "' got status " + this.status + " - " +
                                this.statusText + " and response: " + this.responseText);
                        }
                    };
                    // handling change of ready state (function has its own 'this')
                    xmlhttp.onreadystatechange = function () {
                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                            loader._log.trace("readyState: " + this.readyState + ", status: " + this.status + ", url: " + fullPath);
                        }
                        if (this.readyState == 4) { // AJAX response complete
                            if (this.status == 200) { // AJAX request was successful
                                let contentType = this.getResponseHeader('content-type');
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("content-type: " + contentType);
                                }
                                let contentDisposition = this.getResponseHeader('content-disposition');
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("content-disposition: " + contentDisposition);
                                }
                                let fileName = "download.file";
                                if (contentDisposition != null && contentDisposition != undefined && contentDisposition.length > 0) {
                                    let filenameParts = contentDisposition.split('filename=');
                                    if (filenameParts.length > 1) {
                                        let b64FileName = filenameParts[1].split(';')[0];
                                        fileName = decodeURIComponent(escape(window.atob(b64FileName)));
                                    }
                                }
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("using filename: " + fileName);
                                }
                                if (callback) {
                                    let response = {
                                        ContentType: contentType,
                                        ContentRaw: this.response,
                                        ContentName: fileName
                                    };
                                    if (loader._log !== null && loader._log.isTraceEnabled()) {
                                        loader._log.trace("calling callback with: " + response);
                                    }
                                    callback(response);
                                }
                            }
                            else if (this.status > 0) { // AJAX request not successful
                                if (errorCallback) {
                                    if (loader._log !== null && loader._log.isTraceEnabled()) {
                                        loader._log.trace("calling error callback with: " + this.statusText);
                                    }
                                    errorCallback(fullPath, this.status, this.statusText);
                                }
                                else {
                                    console.error("no error callback - failed to do generic service call raw data to '" + fullPath + "' got status " +
                                        this.status + " - " + this.statusText);
                                }
                            }
                            else {
                                console.error("failed to do generic service call raw data to '" + fullPath + "' got status " + this.status + " - " +
                                    this.statusText);
                            }
                        }
                    };
                    xmlhttp.responseType = 'arraybuffer';
                    xmlhttp.open("GET", fullPath, true);
                    // set selected locale as accept-language header for service layer to use it, if needed
                    if (this._core.Locale.getSelectedLocale()) {
                        xmlhttp.setRequestHeader('Accept-Language', this._core.Locale.getSelectedLocale().LocaleCode);
                    }
                    if (!useProxy) {
                        // add connection id for authorisation
                        xmlhttp.setRequestHeader('ConnectionId', this._core.getCurrentConnectionId());
                    }
                    // add content type (if not in given headers)
                    if (headers == null)
                        headers = {};
                    // add given headers
                    for (let key in headers) {
                        xmlhttp.setRequestHeader(key, headers[key]);
                    }
                    xmlhttp.send();
                }
                catch (ex) {
                    console.error("error while doing generic service call raw data to '" + fullPath + "': ", ex.message);
                    if (errorCallback) {
                        errorCallback(fullPath, 0, ex.message);
                    }
                }
            };
            /**
             * Executes generic service call to get text data.
             * @param fileSpec Remote configuration file to pull (as RemoteConfigurationSpec)
             * @param callback callback function with the successful response
             * @param errorCallback optional callback function in error case
             */
            this.retrieveConfigData = (fileSpec, callback, errorCallback) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.retrieveConfigData()");
                }
                let methodCall = '/GetConfigurationFile.ashx';
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("calling method: " + methodCall);
                }
                let fullPath = this._core.getServer() + methodCall;
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("doing AJAX call to: " + fullPath);
                }
                try {
                    let xmlhttp = new XMLHttpRequest();
                    let loader = this;
                    xmlhttp.onerror = function () {
                        if (errorCallback) {
                            errorCallback(fullPath, this.status, this.statusText);
                        }
                        else {
                            console.error("failed to do generic service call text data to '" + fullPath + "' got status " + this.status + " - " +
                                this.statusText + " and response: " + this.responseText);
                        }
                    };
                    // handling change of ready state (function has its own 'this')
                    xmlhttp.onreadystatechange = function () {
                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                            loader._log.trace("readyState: " + this.readyState + ", status: " + this.status + ", url: " + fullPath);
                        }
                        if (this.readyState == 4) { // AJAX response complete
                            if (this.status == 200) { // AJAX request was successful
                                let contentType = this.getResponseHeader('content-type');
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("content-type: " + contentType);
                                }
                                let response = {
                                    ContentType: contentType,
                                    ContentText: this.responseText
                                };
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("calling callback with: " + response);
                                }
                                callback(response);
                            }
                            else if (this.status > 0) { // AJAX request not successful
                                if (errorCallback) {
                                    if (loader._log !== null && loader._log.isTraceEnabled()) {
                                        loader._log.trace("calling error callback with: " + this.statusText);
                                    }
                                    errorCallback(fullPath, this.status, this.statusText);
                                }
                                else {
                                    console.error("no error callback - failed to do generic service call text data to '" + fullPath + "' got status " +
                                        this.status + " - " + this.statusText);
                                }
                            }
                            else {
                                console.error("failed to do generic service call text data to '" + fullPath + "' got status " + this.status + " - " +
                                    this.statusText);
                            }
                        }
                    };
                    xmlhttp.open("GET", fullPath, true);
                    // add connection id for authorisation
                    //xmlhttp.setRequestHeader('ConnectionId', this._core.getCurrentConnectionId());
                    xmlhttp.setRequestHeader('ConfigInstance', fileSpec.Instance);
                    xmlhttp.setRequestHeader('ConfigFileType', fileSpec.FileType);
                    xmlhttp.setRequestHeader('ConfigId', fileSpec.Id);
                    xmlhttp.send();
                }
                catch (ex) {
                    console.error("error while doing generic service call text data to '" + fullPath + "': ", ex.message);
                }
            };
            /**
             * Executes generic service call to get text data.
             * @param methodCall endpoint and method to call
             * @param callback callback function with the successful response
             * @param errorCallback optional callback function in error case
             * @param useProxy optional decision whether to use the proxy user (default: false)
             */
            this.genericServiceCallTextData = (methodCall, callback, errorCallback, useProxy = false) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.genericServiceCallTextData()");
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("calling method: " + methodCall);
                }
                let fullPath = this._core.getServer() + methodCall;
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("doing AJAX call to: " + fullPath);
                }
                try {
                    let xmlhttp = new XMLHttpRequest();
                    let loader = this;
                    xmlhttp.onerror = function () {
                        if (errorCallback) {
                            errorCallback(fullPath, this.status, this.statusText);
                        }
                        else {
                            console.error("failed to do generic service call text data to '" + fullPath + "' got status " + this.status + " - " +
                                this.statusText + " and response: " + this.responseText);
                        }
                    };
                    // handling change of ready state (function has its own 'this')
                    xmlhttp.onreadystatechange = function () {
                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                            loader._log.trace("readyState: " + this.readyState + ", status: " + this.status + ", url: " + fullPath);
                        }
                        if (this.readyState == 4) { // AJAX response complete
                            if (this.status == 200) { // AJAX request was successful
                                let contentType = this.getResponseHeader('content-type');
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("content-type: " + contentType);
                                }
                                if (callback) {
                                    let response = {
                                        ContentType: contentType,
                                        ContentText: this.responseText
                                    };
                                    if (loader._log !== null && loader._log.isTraceEnabled()) {
                                        loader._log.trace("calling callback with: " + response);
                                    }
                                    callback(response);
                                }
                            }
                            else if (this.status > 0) { // AJAX request not successful
                                if (errorCallback) {
                                    if (loader._log !== null && loader._log.isTraceEnabled()) {
                                        loader._log.trace("calling error callback with: " + this.statusText);
                                    }
                                    errorCallback(fullPath, this.status, this.statusText);
                                }
                                else {
                                    console.error("no error callback - failed to do generic service call text data to '" + fullPath + "' got status " +
                                        this.status + " - " + this.statusText);
                                }
                            }
                            else {
                                console.error("failed to do generic service call text data to '" + fullPath + "' got status " + this.status + " - " +
                                    this.statusText);
                            }
                        }
                    };
                    xmlhttp.open("GET", fullPath, true);
                    // set selected locale as accept-language header for service layer to use it, if needed
                    if (this._core.Locale.getSelectedLocale()) {
                        xmlhttp.setRequestHeader('Accept-Language', this._core.Locale.getSelectedLocale().LocaleCode);
                    }
                    if (!useProxy) {
                        // add connection id for authorisation
                        xmlhttp.setRequestHeader('ConnectionId', this._core.getCurrentConnectionId());
                    }
                    xmlhttp.send();
                }
                catch (ex) {
                    console.error("error while doing generic service call text data to '" + fullPath + "': ", ex.message);
                    if (errorCallback) {
                        errorCallback(fullPath, 0, ex.message);
                    }
                }
            };
            /**
             * Executes generic service call (no payload).
             * @param methodCall endpoint and method to call
             * @param callback callback function with the successful response
             * @param errorCallback optional callback function in error case
             * @param failCallback optional callback function in failed case
             * @param useProxy optional decision whether to use the proxy user (default: false)
             */
            this.genericServiceCall = (methodCall, callback, errorCallback, failCallback, useProxy = false) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.genericServiceCall()");
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("calling method: " + methodCall);
                }
                let fullPath = this._core.getServer() + methodCall;
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("doing AJAX call to: " + fullPath);
                }
                try {
                    let xmlhttp = new XMLHttpRequest();
                    let loader = this;
                    xmlhttp.onerror = function () {
                        if (errorCallback) {
                            errorCallback(fullPath, this.status, this.statusText);
                        }
                        else {
                            console.error("failed to do generic service call to '" + fullPath + "' got status " + this.status + " - " +
                                this.statusText + " and response: " + this.responseText);
                        }
                    };
                    // handling change of ready state (function has its own 'this')
                    xmlhttp.onreadystatechange = function () {
                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                            loader._log.trace("readyState: " + this.readyState + ", status: " + this.status + ", url: " + fullPath);
                        }
                        if (this.readyState == 4) { // AJAX response complete
                            if (this.status == 200) { // AJAX request was successful
                                let shortenedText = this.responseText.length > 500 ? this.responseText.substring(0, 500) + "..." : this.responseText;
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("got response: " + shortenedText);
                                }
                                let response = JSON.parse(this.responseText);
                                if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Error') && response.Connection.Error) {
                                    if (failCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling fail callback with: " + response);
                                        }
                                        failCallback(response);
                                    }
                                    else if (errorCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling error callback with: " + this.statusText);
                                        }
                                        errorCallback(fullPath, this.status, this.statusText);
                                    }
                                    else {
                                        console.error("no error callback - failed to do generic service call to '" + fullPath + "' got message: " +
                                            response.Connection.Message);
                                    }
                                }
                                else {
                                    if (callback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling callback with: " + response);
                                        }
                                        callback(response);
                                    }
                                }
                            }
                            else if (this.status > 0) { // AJAX request not successful
                                let contentType = this.getResponseHeader('content-type');
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("content-type: " + contentType);
                                }
                                let shortenedText = this.responseText.length > 500 ? this.responseText.substring(0, 500) + "..." : this.responseText;
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("got response: " + shortenedText);
                                }
                                if (contentType !== null && contentType.startsWith('application/json')) {
                                    let response = JSON.parse(this.responseText);
                                    if (failCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling fail callback with: " + response);
                                        }
                                        failCallback(response);
                                    }
                                    else if (errorCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling error callback with: " + shortenedText);
                                        }
                                        errorCallback(fullPath, this.status, this.responseText);
                                    }
                                    else {
                                        console.error("no fail callback - failed to do generic service call to '" + fullPath + "' got status " +
                                            this.status + " - " + this.statusText);
                                    }
                                }
                                else {
                                    if (errorCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling error callback with: " + shortenedText);
                                        }
                                        errorCallback(fullPath, this.status, this.responseText);
                                    }
                                    else {
                                        console.error("no error callback - failed to do generic service call to '" + fullPath + "' got status " +
                                            this.status + " - " + this.statusText);
                                    }
                                }
                            }
                            else {
                                console.error("failed to do generic service call to '" + fullPath + "' got status " + this.status + " - " +
                                    this.statusText + " and response: " + this.responseText);
                            }
                        }
                    };
                    xmlhttp.open("GET", fullPath, true);
                    // set selected locale as accept-language header for service layer to use it, if needed
                    if (this._core.Locale.getSelectedLocale()) {
                        xmlhttp.setRequestHeader('Accept-Language', this._core.Locale.getSelectedLocale().LocaleCode);
                    }
                    if (!useProxy) {
                        // add connection id for authorisation
                        xmlhttp.setRequestHeader('ConnectionId', this._core.getCurrentConnectionId());
                        // add user name (probably not used in REST API)
                        xmlhttp.setRequestHeader('Username', this._core.getCurrentUsername());
                    }
                    xmlhttp.send();
                }
                catch (ex) {
                    console.error("error while doing generic service call to '" + fullPath + "': ", ex.message);
                    if (errorCallback) {
                        errorCallback(fullPath, 0, ex.message);
                    }
                }
            };
            /**
             * Executes generic service call (including payload).
             * @param methodCall endpoint and method to call
             * @param payload data to send with the request
             * @param callback callback function with the successful response
             * @param headers optional headers to send with the request
             * @param errorCallback optional callback function in error case
             * @param failCallback optional callback function in failed case
             * @param useProxy optional decision whether to use the proxy user (default: false)
             */
            this.genericServiceCallWithData = (methodCall, payload, callback, headers = {}, errorCallback, failCallback, useProxy = false) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager.genericServiceCallWithData()");
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("calling method: " + methodCall);
                }
                let fullPath = this._core.getServer() + methodCall;
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("doing AJAX call to: " + fullPath);
                }
                try {
                    let xmlhttp = new XMLHttpRequest();
                    let loader = this;
                    xmlhttp.onerror = function () {
                        if (errorCallback) {
                            errorCallback(fullPath, this.status, this.statusText);
                        }
                        else {
                            console.error("failed to do generic service call with data to '" + fullPath + "' got status " + this.status + " - " +
                                this.statusText + " and response: " + this.responseText);
                        }
                    };
                    // handling change of ready state (function has its own 'this')
                    xmlhttp.onreadystatechange = function () {
                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                            loader._log.trace("readyState: " + this.readyState + ", status: " + this.status + ", url: " + fullPath);
                        }
                        if (this.readyState == 4) { // AJAX response complete
                            if (this.status == 200) { // AJAX request was successful
                                let shortenedText = this.responseText.length > 500 ? this.responseText.substring(0, 500) + "..." : this.responseText;
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("got response: " + shortenedText);
                                }
                                let response = JSON.parse(this.responseText);
                                if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Error') && response.Connection.Error) {
                                    if (failCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling fail callback with: " + response);
                                        }
                                        failCallback(response);
                                    }
                                    else if (errorCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling error callback with: " + shortenedText);
                                        }
                                        errorCallback(fullPath, this.status, this.responseText);
                                    }
                                    else {
                                        console.error("no error callback - failed to do generic service call with data to '" + fullPath + "' got message: " +
                                            response.Connection.Message);
                                    }
                                }
                                else {
                                    if (callback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling callback with: " + response);
                                        }
                                        callback(response);
                                    }
                                }
                            }
                            else if (this.status > 0) { // AJAX request not successful
                                let contentType = this.getResponseHeader('content-type');
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("content-type: " + contentType);
                                }
                                let shortenedText = this.responseText.length > 500 ? this.responseText.substring(0, 500) + "..." : this.responseText;
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("got response: " + shortenedText);
                                }
                                if (contentType !== null && contentType.startsWith('application/json')) {
                                    let response = JSON.parse(this.responseText);
                                    if (failCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling fail callback with: " + response);
                                        }
                                        failCallback(response);
                                    }
                                    else if (errorCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling error callback with: " + shortenedText);
                                        }
                                        errorCallback(fullPath, this.status, this.responseText);
                                    }
                                    else {
                                        console.error("no fail callback - failed to do generic service call with data to '" + fullPath + "' got status " +
                                            this.status + " - " + this.statusText);
                                    }
                                }
                                else {
                                    if (errorCallback) {
                                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                                            loader._log.trace("calling error callback with: " + shortenedText);
                                        }
                                        errorCallback(fullPath, this.status, this.responseText);
                                    }
                                    else {
                                        console.error("no error callback - failed to do generic service call with data to '" + fullPath + "' got status " +
                                            this.status + " - " + this.statusText);
                                    }
                                }
                            }
                            else {
                                console.error("failed to do generic service call with data to '" + fullPath + "' got status " + this.status + " - " +
                                    this.statusText + " and response: " + this.responseText);
                            }
                        }
                    };
                    xmlhttp.open("POST", fullPath, true);
                    // set selected locale as accept-language header for service layer to use it, if needed
                    if (this._core.Locale && this._core.Locale.getSelectedLocale()) {
                        xmlhttp.setRequestHeader('Accept-Language', this._core.Locale.getSelectedLocale().LocaleCode);
                    }
                    if (!useProxy) {
                        // add connection id for authorisation
                        xmlhttp.setRequestHeader('ConnectionId', this._core.getCurrentConnectionId());
                        // add user name (probably not used in REST API)
                        xmlhttp.setRequestHeader('Username', this._core.getCurrentUsername());
                    }
                    // add content type (if not in given headers)
                    if (headers == null)
                        headers = {};
                    if (headers["Content-Type"] == undefined) {
                        xmlhttp.setRequestHeader("Content-Type", "application/json");
                    }
                    // add given headers
                    for (let key in headers) {
                        xmlhttp.setRequestHeader(key, headers[key]);
                    }
                    xmlhttp.send(payload);
                }
                catch (ex) {
                    console.error("error while doing generic service call to '" + fullPath + "': ", ex.message);
                    if (errorCallback) {
                        errorCallback(fullPath, 0, ex.message);
                    }
                }
            };
            /**
             * Get a JSON file and execute callback with JSON response.
             * @param url URL to the JSON file
             * @param callback callback function to be executed with the JSON from file
             * @param versioned decision whether to get the JSON file versioned or not
             * @param errorCallback optional callback function in error case
             */
            this._getJSON = (url, callback, versioned, errorCallback) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager._getJSON()");
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("getting JSON from URL: " + url);
                }
                let fullPath = url;
                if (versioned) {
                    fullPath += "?ver=" + this._core.getGatewayVersion();
                }
                else {
                    fullPath += "?_=" + Date.now();
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("doing AJAX call to: " + fullPath);
                }
                try {
                    let xmlhttp = new XMLHttpRequest();
                    let loader = this;
                    xmlhttp.onerror = function () {
                        if (errorCallback) {
                            errorCallback(fullPath, this.status, this.statusText);
                        }
                        else {
                            console.error("failed to get JSON from '" + fullPath + "' got status " + this.status + " - " +
                                this.statusText + " and response: " + this.responseText);
                        }
                    };
                    // handling change of ready state (function has its own 'this')
                    xmlhttp.onreadystatechange = function () {
                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                            loader._log.trace("readyState: " + this.readyState + ", status: " + this.status + ", url: " + fullPath);
                        }
                        if (this.readyState == 4) { // AJAX response complete
                            if (this.status == 200) { // AJAX request was successful
                                let shortenedText = this.responseText.length > 500 ? this.responseText.substring(0, 500) + "..." : this.responseText;
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("calling callback with: " + shortenedText);
                                }
                                callback(JSON.parse(this.responseText));
                            }
                            else if (this.status > 0) { // AJAX request not successful
                                if (errorCallback) {
                                    if (loader._log !== null && loader._log.isTraceEnabled()) {
                                        loader._log.trace("calling error callback with: " + this.statusText);
                                    }
                                    errorCallback(fullPath, this.status, this.statusText);
                                }
                                else {
                                    console.error("no error callback - failed to get JSON from '" + fullPath + "' got status " + this.status + " - " + this.statusText);
                                }
                            }
                            else {
                                console.error("failed to get JSON from '" + fullPath + "' got status " + this.status + " - " + this.statusText + " and response: " + this.responseText);
                            }
                        }
                    };
                    xmlhttp.open("GET", fullPath, true);
                    xmlhttp.send();
                }
                catch (ex) {
                    console.error("error while getting JSON from '" + fullPath + "': ", ex.message);
                    if (errorCallback) {
                        errorCallback(fullPath, 0, ex.message);
                    }
                }
            };
            /**
             * Get a HTML file and execute callback with HTML response.
             * @param url URL to the HTML file
             * @param callback callback function to be executed with the HTML from file
             * @param versioned decision whether to get the HTML file versioned or not
             * @param errorCallback optional callback function in error case
             */
            this._getHTML = (url, callback, versioned, errorCallback) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager._getHTML()");
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("getting HTML from URL: " + url);
                }
                let fullPath = url;
                if (versioned) {
                    fullPath += "?ver=" + this._core.getGatewayVersion();
                }
                else {
                    fullPath += "?_=" + Date.now();
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("doing AJAX call to: " + fullPath);
                }
                try {
                    let xmlhttp = new XMLHttpRequest();
                    let loader = this;
                    xmlhttp.onerror = function () {
                        if (errorCallback) {
                            errorCallback(fullPath, this.status, this.statusText);
                        }
                        else {
                            console.error("failed to get HTML from '" + fullPath + "' got status " + this.status + " - " +
                                this.statusText + " and response: " + this.responseText);
                        }
                    };
                    // handling change of ready state (function has its own 'this')
                    xmlhttp.onreadystatechange = function () {
                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                            loader._log.trace("readyState: " + this.readyState + ", status: " + this.status + ", url: " + fullPath);
                        }
                        if (this.readyState == 4) { // AJAX response complete
                            if (this.status == 200) { // AJAX request was successful
                                let shortenedText = this.responseText.length > 500 ? this.responseText.substring(0, 500) + "..." : this.responseText;
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("calling callback with: " + shortenedText);
                                }
                                callback(this.responseText);
                            }
                            else if (this.status > 0) { // AJAX request not successful
                                if (errorCallback) {
                                    if (loader._log !== null && loader._log.isTraceEnabled()) {
                                        loader._log.trace("calling error callback with: " + this.statusText);
                                    }
                                    errorCallback(fullPath, this.status, this.statusText);
                                }
                                else {
                                    console.error("no error callback - failed to get HTML from '" + fullPath + "' got status " + this.status + " - " + this.statusText);
                                }
                            }
                            else {
                                console.error("failed to get HTML from '" + fullPath + "' got status " + this.status + " - " + this.statusText + " and response: " + this.responseText);
                            }
                        }
                    };
                    xmlhttp.open("GET", fullPath, true);
                    xmlhttp.send();
                }
                catch (ex) {
                    console.error("error while getting HTML from '" + fullPath + "': ", ex.message);
                    if (errorCallback) {
                        errorCallback(fullPath, 0, ex.message);
                    }
                }
            };
            /**
             * Get a CSS file and execute callback with CSS response.
             * @param url URL to the CSS file
             * @param callback callback function to be executed with the CSS from file
             * @param versioned decision whether to get the CSS file versioned or not
             * @param errorCallback optional callback function in error case
             */
            this._getCSS = (url, callback, versioned, errorCallback) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager._getCSS()");
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("getting CSS from URL: " + url);
                }
                let fullPath = url;
                if (versioned) {
                    fullPath += "?ver=" + this._core.getGatewayVersion();
                }
                else {
                    fullPath += "?_=" + Date.now();
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("doing AJAX call to: " + fullPath);
                }
                try {
                    let xmlhttp = new XMLHttpRequest();
                    let loader = this;
                    xmlhttp.onerror = function () {
                        if (errorCallback) {
                            errorCallback(fullPath, this.status, this.statusText);
                        }
                        else {
                            console.error("failed to get CSS from '" + fullPath + "' got status " + this.status + " - " +
                                this.statusText + " and response: " + this.responseText);
                        }
                    };
                    // handling change of ready state (function has its own 'this')
                    xmlhttp.onreadystatechange = function () {
                        if (loader._log !== null && loader._log.isTraceEnabled()) {
                            loader._log.trace("readyState: " + this.readyState + ", status: " + this.status + ", url: " + fullPath);
                        }
                        if (this.readyState == 4) { // AJAX response complete
                            if (this.status == 200) { // AJAX request was successful
                                let shortenedText = this.responseText.length > 500 ? this.responseText.substring(0, 500) + "..." : this.responseText;
                                if (loader._log !== null && loader._log.isTraceEnabled()) {
                                    loader._log.trace("calling callback with: " + shortenedText);
                                }
                                callback(this.responseText);
                            }
                            else if (this.status > 0) { // AJAX request not successful
                                if (errorCallback) {
                                    if (loader._log !== null && loader._log.isTraceEnabled()) {
                                        loader._log.trace("calling error callback with: " + this.statusText);
                                    }
                                    errorCallback(fullPath, this.status, this.statusText);
                                }
                                else {
                                    console.error("no error callback - failed to get CSS from '" + fullPath + "' got status " + this.status + " - " + this.statusText);
                                }
                            }
                            else {
                                console.error("failed to get CSS from '" + fullPath + "' got status " + this.status + " - " + this.statusText + " and response: " + this.responseText);
                            }
                        }
                    };
                    xmlhttp.open("GET", fullPath, true);
                    xmlhttp.send();
                }
                catch (ex) {
                    console.error("error while getting CSS from '" + fullPath + "': ", ex.message);
                    if (errorCallback) {
                        errorCallback(fullPath, 0, ex.message);
                    }
                }
            };
            /**
             * Adds a CSS file to the page.
             * @param url URL to the CSS file
             * @param versioned decision whether to get the CSS file versioned or not
             */
            this._loadCSS = (cssPath, versioned, callback = null, errorCallback = null, forceLoading = false) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager._loadCSS()");
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("loading CSS from URL: " + cssPath);
                }
                if (!this._currentCssId) {
                    this._currentCssId = 'css-id-' + performance.now();
                    this._cssLoaded[this._currentCssId] = {};
                    this._cssFailed[this._currentCssId] = {};
                }
                // check if the CSS is already loaded
                let existingLinkElement = document.querySelector('head>link[rel="stylesheet"][href^="' + cssPath + '"]');
                if (!existingLinkElement || forceLoading) {
                    let fullPath = cssPath;
                    if (versioned) {
                        fullPath += "?ver=" + this._core.getGatewayVersion();
                    }
                    else {
                        fullPath += "?_=" + Date.now();
                    }
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("adding CSS with URL: " + fullPath);
                    }
                    let linkElement = document.createElement("link");
                    linkElement.rel = "stylesheet";
                    linkElement.type = "text/css";
                    linkElement.setAttribute(CSS_ID_ATTRIBUTE, this._currentCssId);
                    linkElement.href = fullPath;
                    this._cssLoaded[this._currentCssId][cssPath] = false;
                    let queue = [];
                    if (callback) {
                        queue.push(callback);
                    }
                    this._cssCallbackQueue[cssPath] = queue;
                    this._cssFailed[this._currentCssId][cssPath] = null;
                    let errorQueue = [];
                    if (errorCallback) {
                        errorQueue.push(errorCallback);
                    }
                    this._cssErrorQueue[cssPath] = errorQueue;
                    linkElement.addEventListener('error', this._failedCSS.bind(this, cssPath));
                    linkElement.addEventListener('load', this._loadedCSS.bind(this, cssPath));
                    document.getElementsByTagName("head")[0].appendChild(linkElement);
                }
            };
            this._loadedCSS = (path) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager._loadedCSS()");
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("CSS loaded: " + path);
                }
                this._cssLoaded[this._currentCssId][path] = true;
                let queue = this._cssCallbackQueue[path];
                let length = queue.length;
                for (let i = 0; i < length; i++) {
                    let callback = queue[i];
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("executing callback " + i);
                    }
                    callback();
                }
            };
            this._failedCSS = (path, event) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager._failedCSS()");
                }
                let errorMsg = event.message !== null ? event.message : "";
                console.warn("failed to load CSS: " + path + " - " + errorMsg);
                this._cssLoaded[this._currentCssId][path] = true;
                this._cssFailed[this._currentCssId][path] = errorMsg;
                let queue = this._cssErrorQueue[path];
                let length = queue.length;
                for (let i = 0; i < length; i++) {
                    let erroCallback = queue[i];
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("executing error callback " + i);
                    }
                    erroCallback(path, errorMsg);
                }
            };
            this._changeCSS = (oldCssId, css) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager._changeCSS()");
                }
                let oldStyle = document.querySelector('#oldApplicationStyle');
                let style = document.querySelector('#applicationStyle');
                if (!style) {
                    style = document.createElement('style');
                    style.id = 'applicationStyle';
                    document.head.appendChild(style);
                }
                if (typeof css != 'object')
                    style.innerHTML = css;
                else
                    style.innerHTML = css.ContentText;
                if (oldStyle) {
                    oldStyle.remove();
                }
                if (oldCssId) {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("removing CSS for id: " + oldCssId);
                    }
                    delete this._cssLoaded[oldCssId];
                    delete this._cssFailed[oldCssId];
                    let linkElements = document.querySelectorAll('head>link[' + CSS_ID_ATTRIBUTE + '="' + oldCssId + '"]');
                    linkElements.forEach(function (linkElement) {
                        linkElement.disabled = true;
                        linkElement.remove();
                    });
                }
            };
            /**
             * Adds a JS file to the page.
             * @param url URL to the JS file
             * @param callback callback function to be executed when the JS file is added to the page
             * @param versioned decision whether to get the JS file versioned or not
             */
            this._loadJS = (jsPath, callback, versioned, errorCallback) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager._loadJS()");
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("loading JS from URL: " + jsPath);
                }
                // check if the JS file is already loaded
                let existingScriptElement = document.querySelector('head>script[src^="' + jsPath + '"]');
                if (existingScriptElement) {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("javascript exists");
                    }
                    let loaded = this._jsLoaded[jsPath];
                    let failedMessage = this._jsFailed[jsPath];
                    if (loaded) {
                        if (this._log !== null && this._log.isTraceEnabled()) {
                            this._log.trace("javascript is loaded, executing callback");
                        }
                        if (failedMessage !== null) {
                            if (errorCallback) {
                                errorCallback(jsPath, failedMessage);
                            }
                        }
                        else if (callback) {
                            callback();
                        }
                    }
                    else {
                        if (this._log !== null && this._log.isTraceEnabled()) {
                            this._log.trace("javascript NOT loaded, adding to queue");
                        }
                        if (callback) {
                            let queue = this._jsCallbackQueue[jsPath];
                            queue.push(callback);
                        }
                        if (errorCallback) {
                            let queue = this._jsErrorQueue[jsPath];
                            queue.push(errorCallback);
                        }
                    }
                }
                else {
                    let fullPath = jsPath;
                    let paramChar = (fullPath.includes("?")) ? "&" : "?";
                    if (versioned)
                        fullPath += `${paramChar}ver=` + this._core.getGatewayVersion();
                    else
                        fullPath += `${paramChar}_=` + Date.now();
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("adding JS with URL: " + fullPath);
                    }
                    let scriptElement = document.createElement('script');
                    scriptElement.type = "text/javascript";
                    scriptElement.src = fullPath;
                    this._jsLoaded[jsPath] = false;
                    let queue = [];
                    if (callback) {
                        queue.push(callback);
                    }
                    this._jsCallbackQueue[jsPath] = queue;
                    this._jsFailed[jsPath] = null;
                    let errorQueue = [];
                    if (errorCallback) {
                        errorQueue.push(errorCallback);
                    }
                    this._jsErrorQueue[jsPath] = errorQueue;
                    scriptElement.addEventListener('error', this._failedJS.bind(this, jsPath));
                    scriptElement.addEventListener('load', this._loadedJS.bind(this, jsPath));
                    document.getElementsByTagName("head")[0].appendChild(scriptElement);
                }
            };
            this._loadedJS = (path) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager._loadedJS()");
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("javascript loaded: " + path);
                }
                this._jsLoaded[path] = true;
                let queue = this._jsCallbackQueue[path];
                let length = queue.length;
                for (let i = 0; i < length; i++) {
                    let callback = queue[i];
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("executing callback " + i);
                    }
                    callback();
                }
            };
            this._failedJS = (path, event) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("LoaderManager._failedJS()");
                }
                let errorMsg = event.message !== null ? event.message : "";
                console.warn("failed to load javascript: " + path + " - " + errorMsg);
                this._jsLoaded[path] = true;
                this._jsFailed[path] = errorMsg;
                let queue = this._jsErrorQueue[path];
                let length = queue.length;
                for (let i = 0; i < length; i++) {
                    let erroCallback = queue[i];
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("executing error callback " + i);
                    }
                    erroCallback(path, errorMsg);
                }
            };
            
            this._core = core;
            this._jsCallbackQueue = {};
            this._jsErrorQueue = {};
            this._jsLoaded = {};
            this._jsFailed = {};
            this._cssCallbackQueue = {};
            this._cssErrorQueue = {};
            this._cssLoaded = {};
            this._cssFailed = {};
        }
    }
    WPTNamespace.LoaderManager = LoaderManager;
})(WPTNamespace || (WPTNamespace = {}));
